import React from "react";
import { Link } from "react-router-dom";
function footer() {
  return (
    <section className="amit-footer-29-main">
      <div className="footer-29 pt-5">
        <div className="container py-lg-3">
          <div className="row footer-top-29">
            <div className="col-lg-6 col-sm-6 footer-list-29 footer-2 mt-lg-0 mt-md-5 mt-4">
              <div className="footer-logo mb-3">
                <h2>
                  <Link className="navbar-brand" to="">
                    <i className="fa fa-logo-icon"></i>
                  </Link>
                </h2>
              </div>
              <p>
                Gaviral Gamtec Private Limited strives to provide cutting-edge software services and
                technical advisory to firms, in order to help them augment their product or service
                offerings by enabling better and seamless engagements with customers/ clients.
              </p>

              {/* <div className=" main-social-footer-29  mt-lg-0 mt-md-2 mt-1 pt-2">
                <a href="#facebook" className="facebook">
                  <span className="fab fa-facebook-f"></span>
                </a>
                <a href="#twitter" className="twitter">
                  <span className="fab fa-twitter"></span>
                </a>
                <a href="#pinterest">
                  <span className="fab fa-pinterest-p"></span>
                </a>
                <a href="#instagram" className="instagram">
                  <span className="fab fa-instagram"></span>
                </a>
              </div> */}
            </div>

            <div className="col-lg-6 col-sm-6 footer-list-29 footer-2 mt-lg-0 mt-md-5 mt-4">
              <div className="pl-3 float-right">
                <div className="cont-details">
                  <div className="cont-top margin-up">
                    <div className="cont-left text-center">
                      <span className="fas fa-map-marked-alt"></span>
                    </div>
                    <div className="cont-right">
                      <p>
                        Gaviral Gamtec Private Limited
                        {/* <br /> 3<sup>rd</sup> Floor Crystal Mall */}
                        <br /> Ganga Vihar Colony, Chinhat
                        <br /> Lucknow, Uttar Pradesh, 227105
                      </p>
                    </div>
                  </div>
                  <div className="cont-top margin-up">
                    <div className="cont-left text-center">
                      <span className="fas fa-blender-phone"></span>
                    </div>
                    <div className="cont-right">
                      <p>
                        <a href="tel:+91 800 4000 008">+91 800 4000 008</a>
                      </p>
                      <p>
                        <a href="tel: +91 800 4800 002">+91 800 4800 002</a>
                      </p>
                    </div>
                  </div>
                  <div className="cont-top margin-up">
                    <div className="cont-left text-center">
                      <span className="fas fa-envelope-open-text"></span>
                    </div>
                    <div className="cont-right">
                      <p>
                        <a href="mailto:contact@gaviralgamtec.com" className="mail">
                          contact@gaviralgamtec.com
                        </a>
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            {/* <div className="col-lg-3 col-sm-6 footer-list-29 footer-2 mt-lg-0 mt-md-5 mt-4">
              <h6 className="footer-title-29">Quick Link</h6>
              <ul>
                <li>
                  <a href="#syn">Symptoms</a>
                </li>

                <li>
                  <a href="#vention">Prevention</a>
                </li>
                <li>
                  <a href="#protect">Protect Youself</a>
                </li>
                <li>
                  <a href="#our">Our Doctors</a>
                </li>
                <li>
                  <a href="#pack">About Corona</a>
                </li>
              </ul>
            </div>
            <div className="col-lg-3 col-sm-6 footer-list-29 footer-2 mt-lg-0 mt-md-5 mt-4">
              <h6 className="footer-title-29">Helpfull link</h6>
              <ul>
                <li>
                  <a href="#terms">Terms of service</a>
                </li>
                <li>
                  <a href="#privacy"> Privacy policy</a>
                </li>
                <li>
                  <a href="#doc"> Documentation</a>
                </li>
                <li>
                  <a href="#support"> Support</a>
                </li>
                <li>
                  <a href="#changelog"> Changelog</a>
                </li>
              </ul>
            </div>
            */}
          </div>
        </div>
      </div>
    </section>
  );
}

export default footer;
